import SiteDevicesTable from '@/features/devices/SiteDevicesTable';
import useAuth from '@/shared/context/auth-context';
import AdminPanelPage from '@/views/layouts/admin-panel/AdminPanelPage';
import { Box, Paper } from '@mui/material';
import { FunctionComponent, ReactElement, useMemo } from 'react';

const SiteSupervisorDevices: FunctionComponent = (): ReactElement => {
	const { user } = useAuth();

	const supervisorSiteId = useMemo(() => user && user.sites[0]?.id, [user]);

	return (
		<AdminPanelPage title="Devices">
			<Box component={Paper} p={3}>
				<SiteDevicesTable siteId={supervisorSiteId} customerName={user?.customer?.name} />
			</Box>
		</AdminPanelPage>
	);
};

export default SiteSupervisorDevices;
